import { ListLayout } from 'components/common/ListLayout'
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import CustomWorkOrderModal from 'components/appointment/CustomWorkOrderModel';
import React, { useEffect, useState } from "react";
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAppointmentView } from 'slices/inviteInterpreterSlice';
import { assignInterpreter } from 'slices/inviteInterpreterSlice';
import { fetchInvitedInterpreters } from 'slices/inviteInterpreterSlice';
import { inviteInterpretersSelector } from 'slices/inviteInterpreterSlice';
import { removeInvitedInterpreters, followUpInvitedInterpreters } from 'slices/inviteInterpreterSlice';
import { fetchAppointmentsInterpreters } from 'slices/inviteInterpreterSlice';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import FullPageLoader from 'components/common/FullPageLoader';

const getBackgroundStyle = (status) => {
  
};

const AppointedInterpretersList = ({ itemId, fetchAppointment, height, vendorType }) => {
  const dispatch = useDispatch()
  const { last_page: totalPages, loader, invitedInterpreters } = useSelector(inviteInterpretersSelector);
  const allInvites = invitedInterpreters?.invites;

  const [sortConfig, setSortConfig] = useState({
    sortBy: "accepted_at",
    sortDirection: "asc",
  });

  const handleSortChange = React.useCallback((direction, field) => {
    setSortConfig({
      sortBy: field,
      sortDirection: direction,
    });
  }, []);

  const appointment = React.useMemo(() => {
    const list = allInvites || [];
    let filtered = list;
    if (vendorType === "agency") {
      filtered = list.filter((item) => item?.interpreter?.vendor_type === "agency");
    } else if (vendorType === "individual") {
      filtered = list.filter((item) => item?.interpreter?.vendor_type !== "agency");
    }

    if (sortConfig.sortBy === "accepted_at") {
      return [...filtered].sort((a, b) => {
        const rawTimeA = a?.accepted_at || (a?.status === 'accepted' ? a?.updated_at : null);
        const rawTimeB = b?.accepted_at || (b?.status === 'accepted' ? b?.updated_at : null);
        const timeA = rawTimeA ? new Date(rawTimeA).getTime() : null;
        const timeB = rawTimeB ? new Date(rawTimeB).getTime() : null;

        if (timeA === null && timeB === null) return 0;
        if (timeA === null) return 1;
        if (timeB === null) return -1;

        return sortConfig.sortDirection === "asc" ? timeA - timeB : timeB - timeA;
      });
    }

    return filtered;
  }, [allInvites, vendorType, sortConfig]);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });

  const [loading, setLoading] = useState(false);
  const refAddutton = React.useRef(null);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);

  const fetchData = async () => {
    dispatch(fetchInvitedInterpreters(itemId))
  };

  React.useEffect(() => {
    fetchData();
  }, [itemId]);

  React.useEffect(() => {
    if (selectedItems.length === 0) {
      setSelectAll(false);
    } else if (appointment?.length > 0 && selectedItems.length === appointment.length) {
      setSelectAll(true);
    }
  }, [selectedItems, appointment]);

  const handleAddInviteInterpreterPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleSubmitInviteInterpreters = React.useCallback(() => {

    const submitCallback = (status, message) => {
      if (status) {
        toast.success(message, {
          className: "successToast",
        })
        setSelectedItems([]);
        setSelectAll(false)
         dispatch(fetchInvitedInterpreters(itemId))
        dispatch(fetchAppointmentView(itemId))
        dispatch(fetchAppointmentsInterpreters(itemId, { exclude_invited: true }))
        
        hideConfirmDialog()
      }
      else {
        toast.error(message,
          {
            className: "errorToast",
          }
        );
      }
    };
    new Swal({
      title: "Are you sure?",
      text: "You want to Remove them?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#075665",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!"
    }).then(result => {
      if (result.isConfirmed) {
        dispatch(removeInvitedInterpreters({ interpreter_ids: selectedItems, }, itemId, submitCallback))
      }
    })
  }, [selectedItems])

  const handleFollowUp = React.useCallback((targetInterpreterIds) => {
    const ids = Array.isArray(targetInterpreterIds) ? targetInterpreterIds : [targetInterpreterIds];
    if (ids.length === 0) return;

    new Swal({
      title: "Are you sure?",
      text: ids.length > 1
        ? `Send follow-up notification to ${ids.length} selected vendors?`
        : "Send follow-up notification to this vendor?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#075665",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Send!"
    }).then(result => {
      if (result.isConfirmed) {
        setLoading(true);
        dispatch(followUpInvitedInterpreters({ interpreter_ids: ids }, itemId, (status, message) => {
          setLoading(false);
          if (status) {
            toast.success(message || "Follow-up notification sent successfully.", {
              className: "successToast",
            });
            setSelectedItems([]);
            setSelectAll(false);
            dispatch(fetchInvitedInterpreters(itemId));
            dispatch(fetchAppointmentView(itemId));
          } else {
            toast.error(message || "Failed to send follow up", {
              className: "errorToast",
            });
          }
        }));
      }
    });
  }, [itemId, dispatch]);

  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = React.useCallback(() => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    // setSelectedItems(appointment.map((inviteInterpreter) => inviteInterpreter.id.toString()))
    setSelectedItems(
      appointment
        .map((inviteInterpreter) => (inviteInterpreter?.interpreter_id || inviteInterpreter?.interpreter?.id)?.toString())
        .filter(Boolean)
    )
  }, [selectedItems, selectAll, appointment])



  const renderTableHeader = React.useCallback(() => {

    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="select-all"
                checked={selectAll}
                onChange={handleToggleSelectAll}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </th>
        {/* <th className="col-1">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Code</p>
          </div>
        </th> */}
        <th className="col-1">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Name</p>
          </div>
        </th>
        <th className="col-2">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Email</p>
          </div>
        </th>
        <th className="col-1">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Phone</p>
          </div>
        </th>
        <th className="col-2">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Languages</p>
          </div>
        </th>
        <th className="col-1">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Status</p>
          </div>
        </th>
        <th className="col-2">
          <TableHeaderItem
            title="Accepted At"
            sortBy="accepted_at"
            sortDirection={sortConfig.sortBy === "accepted_at" ? sortConfig.sortDirection : null}
            callBack={handleSortChange}
          />
        </th>
        <th className="col-2">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <p>Work Order Status</p>
          </div>
        </th>
        <th className="col-1">
          {" "}
          <div>
            <p>Actions</p>
          </div>
        </th>
      </tr>
    );
  }, [selectedItems, appointment, sortConfig, handleSortChange])

  const renderTableContent = React.useCallback(() => {
    return (
      appointment?.map((item, index) => {
        // return <AppointedIntepreterItem itemId={itemId} item={item} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddInviteInterpreterPopUp} setLoading={setLoading}/>
        return (
          <AppointedIntepreterItem
            key={item?.id || index}
            itemId={itemId}
            item={item}
            index={index}
            selectedItems={selectedItems}
            handleChange={handleChange}
            handleAddPopUp={handleAddInviteInterpreterPopUp}
            onFollowUp={handleFollowUp}
            setLoading={setLoading}
          />
        );
      })
    );
  // }, [appointment, selectedItems, itemId]);
  }, [appointment, selectedItems, itemId, handleFollowUp]);

  // const renderTableContent = React.useCallback(() => {
  //   if (!appointment || appointment.length === 0) {
  //     // ✅ Dummy data
  //     const dummy = [
  //       {
  //         id: "dummy1",
  //         code: "INT-001",
  //         first_name: "John",
  //         last_name: "Doe",
  //         email: "john.doe@example.com",
  //         phone: "+1-555-123456",
  //         languages: [{ language: { name: "Spanish" } }],
  //       },
  //       {
  //         id: "dummy2",
  //         code: "INT-002",
  //         first_name: "Jane",
  //         last_name: "Smith",
  //         email: "jane.smith@example.com",
  //         phone: "+1-555-654321",
  //         languages: [{ language: { name: "French" } }],
  //       },
  //     ];

  //     return dummy.map((item, index) => (
  //       <AppointedIntepreterItem
  //         item={item}
  //         index={index}
  //         selectedItems={selectedItems}
  //         handleChange={handleChange}
  //         handleAddPopUp={handleAddInviteInterpreterPopUp}
  //       />
  //     ));
  //   }

  //   return appointment.map((item, index) => (
  //     <AppointedIntepreterItem
  //       item={item?.interpreter}
  //       index={index}
  //       selectedItems={selectedItems}
  //       handleChange={handleChange}
  //       handleAddPopUp={handleAddInviteInterpreterPopUp}
  //     />
  //   ));
  // }, [appointment, selectedItems]);


  const handleClose = React.useCallback(() => {
    refAddutton.current.click();
    setAddForm({ show: false })
  }, [])


  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const renderFooter = React.useCallback(() => {
    return (
      <div className="row-primary" style={{ display: 'flex', gap: '10px' }}>

        {selectedItems?.length > 0 && (
          <button
            onClick={() => handleFollowUp(selectedItems)}
            className="main_button lightBlue"
          >
            {vendorType === "agency"
              ? "Follow Up Agency Vendors"
              : vendorType === "individual"
              ? "Follow Up Individual Vendors"
              : "Follow Up Vendors"}
          </button>
        )}
        <button
          onClick={handleSubmitInviteInterpreters}
          disabled={selectedItems?.length == 0}
          className="main_button"
          style={{

            // float: "right",
            marginRight: 20
          }}
        >
          {/* Remove Vendors */}
          {vendorType === "agency"
            ? "Remove Agency Vendors"
            : vendorType === "individual"
            ? "Remove Individual Vendors"
            : "Remove Vendors"}
        </button>
      </div>
    )
  // }, [selectedItems, vendorType])
  }, [selectedItems, vendorType, handleSubmitInviteInterpreters, handleFollowUp])
  return (
    <>
      <ListLayout
        // title="Invited Vendors - Email"
        title={
          vendorType === "agency"
            ? "Invited Agency Vendors - Email"
            : vendorType === "individual"
            ? "Invited Individual Vendors - Email"
            : "Invited Vendors - Email"
        }
        addButtonDisabled={true}
        buttonTitle="Add InviteVendor"

        renderTableHeader={renderTableHeader}
        renderTableContent={renderTableContent}
        totalPages={totalPages}
        fetchList={fetchData}
        height={height}
        selectedItems={selectedItems}
        // handleRemoveItems={handleRemoveItems}
        // renderAddForm={<AddInviteInterpreter item={addForm.item} show={addForm.show} onClose={handleClose} />}
        refAddutton={refAddutton}
        addForm={addForm}
        showConfirmDialog={showConfirmDialog}
        handleAddPopUp={handleAddInviteInterpreterPopUp}
        renderFooter={renderFooter}
        hideRemoveButton={true}
        // loader={loader}
        hidePageLength={true}
        hidePagination={true}
        hideSearchBar={true}
        showRemoveOnTop={true}
        containerStyle={{
          marginTop: 20
        }}
        time={false}

      >


        {/* {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />} */}

        {/* <AddInviteInterpreter item={addForm.item} show={addForm.show} refAddutton={refAddutton} onClose={handleClose} /> */}
      </ListLayout>
      {loading && <FullPageLoader />}
      {/* Create full page Loader */}

    </>
  )

};

const AppointedIntepreterItem = ({
  item,
  index,
  selectedItems,
  handleChange,
  handleAddPopUp,
  itemId,
  onFollowUp,
  setLoading
}) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [customPricingModal, setCustomPricingModal] = useState({
    show: false,
    interpreter: null,
  });

  const handleAssignInterpreter = (item) => {
    const interpreterId = item?.interpreter?.id;

    Swal.fire({
      title: "Are you sure?",
      text: "You want to assign this vendor?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Assign",
      confirmButtonColor: "#096171",
      cancelButtonColor: "#d33",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const payload = {
          appointment_id: itemId,
          interpreter_id: interpreterId,
        };
        if (item?.interpreter?.vendor_type === 'agency') {
          if (item?.agency_interpreter_id) {
            payload.agency_interpreter_id = item.agency_interpreter_id;
          }
          if (item?.agency_interpreter_name) {
            payload.agency_interpreter_name = item.agency_interpreter_name;
          }
          if (item?.agency_interpreter_code) {
            payload.agency_interpreter_code = item.agency_interpreter_code;
          }
        }
        dispatch(assignInterpreter(
          payload,
          (status, message) => {
            setLoading(false);
            if (status) {
              toast.success(message);
              navigate(`/appointments/view/${itemId}`);
            } else {
              toast.error(message);
            }
          }
        ));
      }
    });
  };

  
  const formatDateTime = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);

      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours.toString().padStart(2, '0') : '12';

      return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
  };
  return (
    <>
      <CustomWorkOrderModal
        item={{ ...customPricingModal.item?.interpreter, appt_id: itemId }}
        show={customPricingModal.show}
        onClose={() => setCustomPricingModal({ show: false, item: null })}
        popupType="custom"
      />

      <tr>

        <td style={getBackgroundStyle(item?.status)}>
          <div className="row_check">
            <span>{index + 1}</span>
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="select-all"
                data-value={item?.interpreter?.id}
                checked={selectedItems.includes(item?.interpreter?.id?.toString())}
                onChange={handleChange}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </td>

        {/* <td style={getBackgroundStyle(item?.status)}>
          <a className='link_preview' target="_blank" href={`/interpreters/update/${item?.interpreter?.id}`}>
            {item?.interpreter?.code}
          </a></td> */}

        <td style={getBackgroundStyle(item?.status)}>
          <a className='link_preview' target="_blank" href={`/interpreters/update/${item?.interpreter?.id}`}>
          {item?.interpreter?.first_name + " " + item?.interpreter?.last_name}</a></td>

        <td style={getBackgroundStyle(item?.status)}>{item?.interpreter?.user?.email}</td>

        <td style={getBackgroundStyle(item?.status)}>{item?.interpreter?.phone}</td>

        <td style={getBackgroundStyle(item?.status)}>{item?.interpreter?.languages?.map((l) => l?.language?.name + ", ")}</td>

        <td style={getBackgroundStyle(item?.status)}>{item?.status}</td>

        <td style={getBackgroundStyle(item?.status)}>
          {item?.accepted_at
            ? formatDateTime(item.accepted_at)
            : item?.status === 'accepted' && item?.updated_at
            ? formatDateTime(item.updated_at)
            : '—'}
        </td>

        <td style={getBackgroundStyle(item?.status)}>{item?.work_order_status}</td>

          <td style={getBackgroundStyle(item?.status)}>
            <div className='d-flex gap-2'>
            {item?.status === "pending" && (
              <button
                className="main_button lightBlue"
                onClick={() => onFollowUp && onFollowUp(item?.interpreter_id || item?.interpreter?.id)}
              >
                Follow Up
              </button>
            )}
            {item?.status == "accepted" &&
            <button
              className="main_button"
              onClick={() => setCustomPricingModal({ show: true, item })}
            >
              Custom Work Order
            </button>
        }
        {item?.status == "accepted" && 
            <button
              className="main_button green"
              onClick={() => handleAssignInterpreter(item)}
            >
              Assign
            </button>
          
        }
          </div>
          </td>
      </tr>
    </>
  );
};


export default AppointedInterpretersList